import styled, { css } from 'styled-components';
import { hideVisually } from 'polished';

import IconCheckMark from '../../images/IconCheckMark';
import { speed, easing } from '../../styles/animation';
import breakpoints from '../../styles/breakpoints';
import responsiveStyle from '../../utils/responsiveStyle';

import theme from '../../styles/theme';

export const Bullet = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  ${responsiveStyle('width', [28, 48], breakpoints.fonts)};
  ${responsiveStyle('height', [28, 48], breakpoints.fonts)};

  margin: 0;
  padding: 0;

  background-color: ${theme.colors.mineShaft400};
  border: 2px solid ${theme.colors.brownGrey};
  border-radius: 50%;
  outline: 0;

  transform: scale(1);

  transition-timing-function: ${easing.inOutBack};
  transition-duration: ${speed.fast};
  transition-property: transform;

  :enabled {
    cursor: pointer;
  }

  :enabled:focus,
  :enabled:hover {
    transform: scale(1.2);
  }

  appearance: none;

  ::before {
    position: absolute;

    ${responsiveStyle('width', [14, 22], breakpoints.fonts)};
    ${responsiveStyle('height', [14, 22], breakpoints.fonts)};

    background-color: ${theme.colors.primary};

    border-radius: 50%;

    transform: scale(0);
    opacity: 0;

    transition-timing-function: ${easing.inOutBack};
    transition-duration: ${speed.fast};
    transition-property: opacity, transform;

    content: '';

    will-change: opacity, transform;
  }
`;

export const CheckMark = styled(IconCheckMark)`
  position: absolute;

  height: 40%;

  margin-top: 3%;

  transform: scale(0);
  opacity: 0;

  transition-timing-function: ${easing.inOutBack};
  transition-duration: ${speed.fast};
  transition-property: opacity, transform;

  will-change: opacity, transform;

  path {
    fill: ${theme.colors.mineShaft};
  }
`;

export const Step = styled.div`
  position: relative;

  display: flex;
  flex-grow: 2;
  align-items: center;
  justify-content: center;

  ::after {
    position: absolute;
    z-index: -1;

    width: 100%;
    height: 2px;

    background-color: ${theme.colors.brownGrey};

    content: '';
  }

  :first-child,
  :last-child {
    flex-grow: 1;
  }

  :first-child {
    justify-content: flex-start;
  }

  :last-child {
    justify-content: flex-end;
  }

  ${(props) =>
    props.active &&
    css`
      ${Bullet}::before {
        transform: scale(1);
        opacity: 1;
      }
    `}

  ${(props) =>
    props.done &&
    css`
      ${Bullet} {
        border-color: ${theme.colors.primary};
        background-color: ${theme.colors.primary};
      }

      ${CheckMark} {
        transform: scale(1);
        opacity: 1;
      }
    `}
`;

export const Title = styled.span`
  ${hideVisually}
`;

const StyledStepper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export default StyledStepper;
